// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Batches Section Styling */
.batches-section {
  background-color: #f8f9fa;
  padding: 2rem;
  border-radius: 4px;
  border: 1px solid #dee2e6;
}

/* Create Batch Section */
.create-batch-section {
  background-color: #ffffff;
  padding: 1.5rem;
  border: 1px solid #dee2e6;
  border-radius: 4px;
}

.create-batch-section h4 {
  color: #0b2d71;
}

/* Test Selection */
.test-selection {
  margin-left: 1rem;
}

.form-check-input {
  cursor: pointer;
  width: 1.1rem;
  height: 1.1rem;
}

.form-check-label {
  margin-left: 1.5rem;
}

/* Existing Batches Section */
.existing-batches-section h4 {
  color: #0b2d71;
}

/* Table Styling */
.table {
  background-color: #ffffff;
  font-size: 0.9rem;
}

.table thead th {
  background-color: #e9ecef;
  font-weight: bold;
  border: 1px solid #dee2e6;
}

.table tbody td {
  border: 1px solid #dee2e6;
  vertical-align: middle;
}
`, "",{"version":3,"sources":["webpack://./projects/cemsys/src/app/project-details/spacer-details/batches/batches.component.css"],"names":[],"mappings":"AAAA,4BAA4B;AAC5B;EACE,yBAAyB;EACzB,aAAa;EACb,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA,yBAAyB;AACzB;EACE,yBAAyB;EACzB,eAAe;EACf,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,cAAc;AAChB;;AAEA,mBAAmB;AACnB;EACE,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,aAAa;EACb,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,6BAA6B;AAC7B;EACE,cAAc;AAChB;;AAEA,kBAAkB;AAClB;EACE,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;EACzB,iBAAiB;EACjB,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,sBAAsB;AACxB","sourcesContent":["/* Batches Section Styling */\n.batches-section {\n  background-color: #f8f9fa;\n  padding: 2rem;\n  border-radius: 4px;\n  border: 1px solid #dee2e6;\n}\n\n/* Create Batch Section */\n.create-batch-section {\n  background-color: #ffffff;\n  padding: 1.5rem;\n  border: 1px solid #dee2e6;\n  border-radius: 4px;\n}\n\n.create-batch-section h4 {\n  color: #0b2d71;\n}\n\n/* Test Selection */\n.test-selection {\n  margin-left: 1rem;\n}\n\n.form-check-input {\n  cursor: pointer;\n  width: 1.1rem;\n  height: 1.1rem;\n}\n\n.form-check-label {\n  margin-left: 1.5rem;\n}\n\n/* Existing Batches Section */\n.existing-batches-section h4 {\n  color: #0b2d71;\n}\n\n/* Table Styling */\n.table {\n  background-color: #ffffff;\n  font-size: 0.9rem;\n}\n\n.table thead th {\n  background-color: #e9ecef;\n  font-weight: bold;\n  border: 1px solid #dee2e6;\n}\n\n.table tbody td {\n  border: 1px solid #dee2e6;\n  vertical-align: middle;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
